export const NAV_ITEMS = [
  { label: 'About', to: '/#about' },
  { label: 'Experience', to: '/#experience' },
  { label: 'Work', to: '/portfolio' },
  { label: 'Contact', to: '/#contact' },
];
